import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { SimplePage } from 'common';
import { fetchCookiePolicy } from './CookiePolicySlice';
import { CookiePolicyContentSelector } from './CookiePolicyContentSelector';

export function useCookiePolicy(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchCookiePolicy, CookiePolicyContentSelector);
}
